module.exports = __webpack_public_path__ + "static/media/share-icon.230ca9a1.svg";